import React from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';
import { alpha } from '@mui/material/styles';

import SortableTableHeaderCell from '../../shared/SortableTableHeaderCell';
import type { SortDirection } from '../../shared/useTableSort';

export type BlackoutSortField = 'name' | 'from__c' | 'rooms' | 'days';

interface Props {
  columnCount: number;
  sortField: BlackoutSortField;
  sortDirection: SortDirection;
  onSortChange: (field: BlackoutSortField) => void;
}

export default function BlackoutTableHeader({ columnCount, sortField, sortDirection, onSortChange }: Props) {
  return (
    <TableHead>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.14),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell colSpan={columnCount}>Parent Salesforce blackout dates</TableCell>
      </TableRow>
      <TableRow
        sx={{
          '& .MuiTableCell-head': {
            bgcolor: (theme) => alpha(theme.palette.info.main, 0.06),
            color: 'info.dark',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 0,
            textTransform: 'uppercase',
          },
        }}
      >
        <TableCell />
        <SortableTableHeaderCell
          field="name"
          sortField={sortField}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
        >
          Name
        </SortableTableHeaderCell>
        <SortableTableHeaderCell
          field="rooms"
          sortField={sortField}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
        >
          Rooms (extracted)
        </SortableTableHeaderCell>
        <SortableTableHeaderCell
          field="from__c"
          sortField={sortField}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
        >
          Range
        </SortableTableHeaderCell>
        <SortableTableHeaderCell
          field="days"
          sortField={sortField}
          sortDirection={sortDirection}
          onSortChange={onSortChange}
        >
          Days (extracted)
        </SortableTableHeaderCell>
      </TableRow>
    </TableHead>
  );
}
